import { ComponentType } from "react";
import { PersonWorkTimeInCompanyFragment } from "gql/graphql";
import { Hidable, NotSpecified, Value } from "@/shared/value";

/**
 * Стаж человека в компании. Считает бэкенд, поэтому на месте показа ничего не
 * вычисляется — но пустой стаж и стаж, равный нулю, здесь не путаются.
 */
export function PersonWorkTimeInCompany({
  data,
  whenEmpty: WhenEmpty = NotSpecified,
}: {
  data?: Hidable<PersonWorkTimeInCompanyFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={WhenEmpty}>
      {(person) =>
        person.workTimeInCompany === null ||
        person.workTimeInCompany === undefined ? (
          <WhenEmpty />
        ) : (
          <span>{person.workTimeInCompany}</span>
        )
      }
    </Value>
  );
}
